export const createStyleTemplatePageMessages = {
  pageTitle: 'Create Style Template',
  pageDescription: 'Create a new style template for consistent storytelling',
  formContainerAriaLabel: 'Style template creation form',
} as const;
